import dashboard from './dashboard';
import memberManagement from './memberManagement';
import reports from './reports';
import bets from './bets';
import subAgents from './subAgents';


// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    // items: [dashboard, memberManagement, reports, bets]
    items: [dashboard, memberManagement,subAgents,reports,bets]
};

export default menuItems;
